module.exports = __webpack_public_path__ + "img/43244631003001.941dc8a9.png";